export const professors = {
    over: " and ",
    people: " others",
}
